import bite from '@/views/components/assets/review/bite.avif'
import hegelmann from '@/views/components/assets/review/hegelmann.avif'
import foxway from '@/views/components/assets/review/foxway.avif'
import agrokoncernasLogo from '@/views/components/assets/review/agrokoncernas.avif'
import epsog from '@/views/components/assets/review/epsog.avif'

export type ReviewLogoKey =
  | 'bite'
  | 'hegelmann'
  | 'foxway'
  | 'agrokoncernas'
  | 'epsog'

export const REVIEW_LOGOS: Record<ReviewLogoKey, { src: string; alt: string }> =
  {
    bite: { src: bite, alt: 'Bite Group' },
    hegelmann: { src: hegelmann, alt: 'Hegelmann Group' },
    foxway: { src: foxway, alt: 'Foxway' },
    agrokoncernas: { src: agrokoncernasLogo, alt: 'Client testimonial logo' },
    epsog: { src: epsog, alt: 'EPSO-G' },
  }
